/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditSMS/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { colors, subtleShadow, fontWeights } from 'ui/theme';

export const MessageHeaderAndroid = styled.div`
  align-items: center;
  background-color: ${colors.white};
  box-sizing: border-box;
  justify-content: space-between;
  display: flex;
  flex: 0 0 48px;
  height: 60px;
  padding: 8px 12px;
  width: 100%;
  ${subtleShadow}
`;

export const MessageBody = styled.div`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  font-weight: ${fontWeights.regular};
  overflow-x: hidden;
  overflow-y: auto;
  padding: 14px;
  padding-bottom: 42px;
  width: 100%;
`;

export const MessageBodyAndroidDate = styled.div`
  color: ${colors.grey60};
  flex: 0 0 auto;
  font-size: 13px;
  text-align: center;
  width: 100%;
`;

export const MessageBodyAndroidMessageContainer = styled.div`
  align-items: flex-end;
  column-gap: 7px;
  display: flex;
  flex: 0 0 auto;
  line-height: 1.4;
  margin-top: 7px;
`;

export const MessageBodyAndroidMessage = styled.div`
  background-color: ${colors.grey5};
  border-radius: 4px;
  color: ${colors.black};
  flex: 0 0 auto;
  font-size: 12px;
  max-width: 197px;
  overflow-wrap: break-word;
  padding: 8px;
  white-space: pre-wrap;
`;

export const MessageHeaderIos = styled.div`
  place-items: center;
  background-color: #F6F6F6;
  border-bottom: 1px solid #E5E5E5;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 24px 1fr 24px;
  height: 85px;
  padding-top: 7px;
  width: 100%;
`;

export const AvatarContainer = styled.div`
  background-image: linear-gradient(#A5AAB7, #858794);
  border-radius: 50%;
  height: 34px;
  width: 34px;
`;

export const MessageBodyIosDateTime = styled.div`
  color: ${colors.black};
  flex: 0 0 auto;
  font-size: 10px;
  text-align: center;
  text-transform: capitalize;
  width: 100%;
`;

export const MessageBodyIosMessage = styled.div`
  background-color: #E9E8EB;
  border-radius: 7px;
  color: ${colors.black};
  flex: 0 0 auto;
  font-size: 12px;
  line-height: 1.3;
  margin-top: 7px;
  max-width: 206px;
  overflow-wrap: break-word;
  padding: 6px;
  white-space: pre-wrap;
`;
